import { addClickOutsideListener } from "./helpers/dialogHelpers";

const membershipDialog = <HTMLDialogElement>document.querySelector("#MembershipDialog");
const openMembershipDialogButtons = <NodeListOf<HTMLDivElement>>document.querySelectorAll(".open-membership");

if (membershipDialog && openMembershipDialogButtons) {
    window.addEventListener("beforeprint", () => {
        membershipDialog.classList.add("print");
    });

    window.addEventListener("afterprint", () => {
        membershipDialog.classList.remove("print");
    });

    const close = <HTMLButtonElement>membershipDialog.querySelector(".close-button");

    openMembershipDialogButtons.forEach((b) => {
        b.addEventListener("click", () => {
            membershipDialog.showModal();
            const fee = <HTMLInputElement>membershipDialog.querySelector(`input[data-id='${b.dataset.id}']`);
            fee.checked = true;
        });
    });

    close.addEventListener("click", () => {
        membershipDialog.close();
    });

    addClickOutsideListener(membershipDialog);
}
